/* Import Module */
import $ from "jquery";

/* Define Script */
export const toggleAccordion = (id: string) => {
  const elementId = "#" + id;
  const element = $(elementId);
  $(element).toggleClass("active");
  $(element).next().slideToggle("normal");
};
